import { useEffect, useState } from 'react'
import { Modal } from './Modal.tsx'
import './SettingsModal.css'
import './BotConfigModal.css'

export const BotConfigModal = ({ isOpen, onClose, roleId, name, peerService }: any) => {
  const [fields, setFields] = useState<any[]>([])
  const [values, setValues] = useState<any>({})
  const [loaded, setLoaded] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!isOpen || !roleId || !peerService) return
    setError('')
    setLoaded(false)
    peerService
      .getWorkerConfig(roleId)
      .then((result: any) => {
        setFields(result.fields || [])
        setValues(result.values || {})
        setLoaded(true)
      })
      .catch((err: any) => setError(err.message || 'Failed to load config'))
  }, [isOpen, roleId, peerService])

  const handleChange = (key: string, value: any) => {
    setValues((prev: any) => ({ ...prev, [key]: value }))
  }

  const handleSave = async () => {
    setIsSaving(true)
    setError('')
    try {
      await peerService.updateWorkerConfig(roleId, values)
      onClose()
    } catch (err: any) {
      setError(err.message || 'Failed to save config')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <div className="settings-modal">
        <div className="settings-header">
          <h2>{name || 'Bot'} Config</h2>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="settings-content">
          {!loaded && !error && <div className="bot-config-loading">Loading...</div>}
          {loaded &&
            fields.map((f: any) => (
              <div key={f.key} className="bot-config-field">
                <label className="bot-config-label">{f.label}</label>
                {f.type === 'textarea' ? (
                  <textarea
                    className="provider-input bot-config-textarea"
                    value={values[f.key] || ''}
                    onChange={e => handleChange(f.key, e.target.value)}
                    placeholder={f.placeholder}
                    rows={3}
                  />
                ) : (
                  <input
                    className="provider-input"
                    type={f.type}
                    value={values[f.key] ?? ''}
                    onChange={e =>
                      handleChange(
                        f.key,
                        f.type === 'number' ? Number(e.target.value) : e.target.value,
                      )
                    }
                    placeholder={f.placeholder}
                    step={f.step}
                  />
                )}
              </div>
            ))}
          {loaded && fields.length === 0 && (
            <div className="bot-config-loading">No configurable options</div>
          )}
          {error && <div className="settings-error">{error}</div>}
        </div>

        <div className="settings-footer">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="save-button"
            onClick={handleSave}
            disabled={isSaving || !loaded || fields.length === 0}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
